import React, { useEffect, useState } from "react";
import { Col, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  DaySpan,
  TechniciansContainer,
} from "../../../shared/components/form/SelectTechnicianPopup";
import {
  ActionIconContainer,
  AddFormButton,
  ColumnHeaderRow,
  DataRow,
  ScrollableDiv,
  TableContainer,
} from "../../../shared/components/TableElements";
import styled from "styled-components";
import { colorRowHover } from "../../../utils/palette";

const SelectAssistantTechPopup = ({
  showPopup,
  setShowPopup,
  assistantTechs,
  setAssistantTechs,
  techniciansList,
  handleSelect,
  isReadOnly,
}) => {
  const { t } = useTranslation("common");

  const { currency } = useSelector((state) => state.units);

  const daysOfWeekObj = {
    1: "M",
    2: "T",
    3: "W",
    4: "T",
    5: "F",
    6: "S",
    7: "S",
  };

  const [selected, setSelected] = useState([]);

  //Load the value of assistantTechs received from props if it exists
  useEffect(() => {
    if (assistantTechs) {
      setSelected(assistantTechs);
    }
  }, [assistantTechs]);

  const handleTechClick = (item) => {
    if (isReadOnly) return;
    const isSelected = selected.some((tech) => tech.user_id === item.user_id);
    const newSelectedItems = isSelected
      ? selected.filter((tech) => tech.user_id !== item.user_id)
      : [...selected, item];

    setSelected(newSelectedItems);
  };

  //   const handleSelect = () => {
  //     setAssistantTechs(selected);
  //     setShowPopup(false);
  //   };

  return (
    <Modal
      show={showPopup}
      onHide={() => setShowPopup((prev) => !prev)}
      size="lg"
    >
      <Modal.Body
        style={
          {
            //height: "-webkit-fill-available",
            //height: `${window.innerHeight - 100}px`,
          }
        }
      >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5>{t("select_asst_techs")}</h5>
          <ActionIconContainer onClick={() => setShowPopup((prev) => !prev)}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
        <TableContainer className="m-0 p-0">
          <ColumnHeaderRow
          // style={{
          //   border: `1px solid ${colorLightGray}`,
          //   //background: colorLightGray,
          // }}
          // className="py-2 mx-0"
          >
            <Col md={1}></Col>
            <Col md={3}>
              <span>{t("name")}</span>
            </Col>
            <Col md={2}>
              <span>{t("rate_per_hour")}</span>
            </Col>
            <Col md={3}>
              <span>{t("working_days")}</span>
            </Col>
            <Col md={3}>
              <span>{t("working_hours")}</span>
            </Col>
          </ColumnHeaderRow>
          <ScrollableDiv $maxHeight={`${window.innerHeight - 300}px`}>
            {techniciansList?.length === 0 && (
              <div className="d-flex justify-content-center p-2">
                {t("no_records")}
              </div>
            )}
            {techniciansList?.map((tech) => {
              return (
                <TechnicianRow
                  key={tech.user_id}
                  onClick={() => handleTechClick(tech)}
                  //style={{ border: `1px solid ${colorLightGray}` }}
                  className="m-0"
                  $readOnly={isReadOnly}
                >
                  <Col md={1}>
                    <div>
                      <input
                        type="checkbox"
                        name="technician"
                        //value={selected.user_id}
                        checked={selected.some(
                          (u) => u.user_id === tech.user_id
                        )}
                        //onChange={(e) => console.log(e.target.value)}
                        style={{ marginTop: "0.25rem" }}
                        readOnly
                        disabled={isReadOnly}
                      />
                    </div>
                  </Col>
                  <Col md={3}>
                    <span>{tech.label}</span>
                  </Col>
                  <Col md={2}>
                    <span>{`${tech.hourly_rate} ${currency}`}</span>
                  </Col>
                  <Col md={3}>
                    {[1, 2, 3, 4, 5, 6, 7]?.map((no) => (
                      <React.Fragment key={no}>
                        <DaySpan
                          active={tech?.working_days
                            ?.split(":")
                            ?.includes(no.toLocaleString())}
                        >
                          {daysOfWeekObj[no]}
                        </DaySpan>
                      </React.Fragment>
                    ))}
                  </Col>
                  <Col md={3}>
                    <span>
                      {`${tech.starting_time?.slice(
                        0,
                        5
                      )} - ${tech.ending_time?.slice(0, 5)}`}
                    </span>
                  </Col>
                </TechnicianRow>
              );
            })}
          </ScrollableDiv>
        </TableContainer>
        <div className="d-flex justify-content-end align-items-center mt-3">
          <AddFormButton
            onClick={() => handleSelect(selected)}
            disabled={isReadOnly}
          >
            {t("select")}
          </AddFormButton>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SelectAssistantTechPopup;

//styles

export const TechnicianRow = styled(DataRow)`
  ${(p) =>
    !p.$readOnly &&
    `
    cursor: pointer;
    &:hover {
    background: ${colorRowHover};
    }
        `};
`;
